// extracted by mini-css-extract-plugin
export default {"showAlternativesButton":"ShowAlternativesButton_showAlternativesButton__OATZJ"};